module.exports = __webpack_public_path__ + "static/Yes-d9ea2e8a7a1fc60d9126b81a44d62fe8.png";